import { render, staticRenderFns } from "./tannerComponentShow.vue?vue&type=template&id=45c325da&scoped=true&"
import script from "./tannerComponentShow.vue?vue&type=script&lang=js&"
export * from "./tannerComponentShow.vue?vue&type=script&lang=js&"
import style0 from "./tannerComponentShow.vue?vue&type=style&index=0&id=45c325da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c325da",
  null
  
)

export default component.exports